export default __webpack_public_path__ + "static/media/logoMeta.ccec694f.png";